// extracted by mini-css-extract-plugin
export var productImage = "_ow-0";